const shopcart = {
  namespaced: true,
  state: {
    commodities: [],
    total: 0,
    countofcommodity: 0,
  },
  mutations: {
    CLEAR: (state) => {
      state.commodities.length = 0;
      state.total = 0;
      state.countofcommodity=0;
    },
    COUNT: (state) => {
      state.total = 0;
      let x = 0;
      state.commodities.forEach((element) => {
        x = x + element.price * element.quantity;
      }); //计算一下总价
      state.total =  x;
    },
    COUNTCOMMODITY: (state) => {
      state.countofcommodity = 0;
      state.commodities.forEach((element) => {
        state.countofcommodity = state.countofcommodity + element.quantity;
      }); 
    },
    ADD_COMMODITY: (state, commodity) => {


      let index = state.commodities.indexOf(commodity);
      if (-1 === index) {
        state.commodities.push(commodity);
      }
     // console.log("vuex:", state.commodities)
    },
    DEL_COMMODITY: (state, commodity) => {
      
      let index = state.commodities.indexOf(commodity);
      if (-1 === index) {
        return;
      } else {
        state.commodities.splice(index, 1);
      }
    },
  },
  actions: {
    addCommodity({ commit }, commodity) {
      commit('ADD_COMMODITY', commodity);
      commit('COUNT');
      commit('COUNTCOMMODITY');
    },
    delCommodity({ commit }, commodity) {
      commit('DEL_COMMODITY', commodity);
      commit('COUNT');
      commit('COUNTCOMMODITY');
    },
    getCount({ commit }) {
      commit('COUNT');
    },
    getCountOfCommodity({ commit }) {
      commit('COUNTCOMMODITY');
    },
    clear({ commit }) {
      commit('CLEAR');
    },
  },
  getters: {
    shopcartData: state => {
      return {
        commodities:state.commodities,
        total:state.total,
        countofcommodity:state.countofcommodity
      };
    },
  },
};

export default shopcart;
